{
  "countries": {
    "Finland": "Finland",
    "Sweden": "Sweden",
    "Norway": "Norway",
    "Denmark": "Denmark",
    "UnitedKingdom": "United Kingdom"
  },
  "userRoles": {
    "admin": "admin",
    "approver": "approver",
    "user": "user",
    "user-lite": "no rights",
    "orderer": "orderer"
  },
  "companyDevice": "Company device",
  "inactiveUser": "Inactive user"
}
